import React from 'react';

export class HttpStatus {
  private httpStatusCode: number;
  constructor(httpStatusCode: number) {
    this.httpStatusCode = httpStatusCode;
  }

  setStatusNotFound() {
    this.httpStatusCode = 404;
  }

  getStatusCode() {
    return this.httpStatusCode;
  }
}

export const HttpStatusContext = React.createContext<HttpStatus | undefined>(undefined);
